/**
 * The column a preview's words are read in.
 *
 * Both text bodies take it, so a Markdown file and the plain text beside it sit on the same
 * measure — 72 characters, the line length prose is read at, centred in whatever width the
 * dialog has.
 */
export const PREVIEW_READING_COLUMN_CLASS =
  "mx-auto w-full max-w-[72ch] px-5 py-4 min-[840px]:px-6";
